<template>
  <v-content style="background-color: #f9f9f9;">
    <div class="point text-center" v-if="point.disp_type === 0">
      <qrcode :value="this.point.qr_code" :options="{ width: 184}" class="mt-5" style="background-color: white;"></qrcode>
      <div class="mt-5 mb-5" v-bind:style="{ background: 'linear-gradient(170deg, #ffffff, ' + this.backgroundColor + ', #ffffff)'}" style="width: 100%; height: 30px"></div>
      <div class="text-center" v-if="point.points_held || point.points_held === 0">
        <span style="font-weight: bold;">ここ1年間の累計泊数</span><br>
        <span class="big-point">{{ point.points_held }}</span>
        <span class="small-bold-text">泊</span>
      </div>
      <div class="grid-container">
        <div class="right-align" v-if="point.expiration_date">泊数有効期限：</div><div class="left-align">{{ getDateFormat(this.point.expiration_date) }}</div>
      </div>
      <div class="mt-2 mb-8 text-center" v-if="point.result_status === 0">
            <v-btn rounded class="pl-12 px-12 maincolor-bg default_button2 large" @click.stop="goStayHistory()">宿泊履歴</v-btn>
      </div>
      <div class="grid-container">
        <div class="right-align" v-if="point.wincal_id">会員番号：</div><div class="left-align">{{ point.wincal_id }}</div>
        <div class="right-align" v-if="point.name">会員名：</div><div class="left-align">{{ point.name }}</div>
        <div class="right-align" v-if="point.rank">ランク：</div><div class="left-align">{{ point.rank }}</div>
      </div>
      <img class="mt-1" :src="point.rank_explain_image_path" style="width:auto; max-width:100%;" v-if="point.rank_explain_image_path"/>
      <p class="caption" style="margin: 30px" v-html="point.rank_explain_text" v-else-if="point.rank_explain_text"></p>
    </div>
    <div class="point text-center" v-if="point.disp_type === 1">
      <p></p>
      <p class="subtitle-2 font-weight-black" style="margin: 2px">ポイント機能のご利用には<br>{{ point.member_service_name }}との連携が必要です。</p>
      <img class="mt-1" :src="point.rank_explain_image_path" style="width:auto; max-width:100%;" v-if="point.rank_explain_image_path"/>
      <p class="caption" style="margin: 30px" v-html="point.rank_explain_text" v-else-if="point.rank_explain_text"></p>
      <v-btn rounded class="mt-5 maincolor-bg default_button2 large" @click.stop="goAuth()">{{ point.link_button_name }}</v-btn>
      <p class="mt-2 mb-2 text-caption" v-html="point.link_button_remark" v-if="point.link_button_remark"></p>
      <v-btn rounded class="mt-5 maincolor-bg default_button2 large" @click.stop="registerNewMember()">{{ point.regist_button_name }}</v-btn>
      <p class="mt-2 mb-4 text-caption" v-html="point.regist_button_remark" v-if="point.regist_button_remark"></p>
    </div>
    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="" indeterminate></v-progress-circular>
    </v-overlay>
  </v-content>
</template>

<script>
import moment from "moment"
export default {
  data: () => ({
    init: [],
    point: [],
    routingResult: [],
    loading: false,
    backgroundColor: 'white',
  }),
  created () {
    this.init = this.storageGet("*")
  },
  async mounted() {
    this.loading = true
    try {
      await this.getPoint();
      this.setBackgroundColor();
      this.loading = false
    }catch (e) {
      this.loading = false
    }
  },
  methods: {
    getDateFormat(date) {
      if(typeof date === 'undefined' || !date) {
        return null;
      }
      var d = moment(date);
      if(d.isValid()) {
        return d.format('YYYY年MM月DD日');
      }
      return date;
    },
    async getPoint() {
      this.loading = true;

      try {
        const req = {params: {
          'sid': this.init.sid,
          'device_uid': this.init.device_uid,
          'device_id': this.init.device_id,
          'os': this.init.os,
          'key': this.init.key
        }}
        var res = await this.apiCall('/point-external/wincal-show', req, 'get');
        if (!res) throw "point_get_error";
        this.$set(this, 'point', res);
        if (res.result_status) throw "point_get_error";
      } catch(e) {
        if(res.result_status){
            this.callDialog('エラー', res.message, 3);
        } else {
            this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
        }
      } finally {
        this.loading = false;
      }
    },
    setBackgroundColor() {
      if(this.point.rank_color_code === null) {
        this.$set(this, 'backgroundColor', '#808080');
        return;
      }
      this.$set(this, 'backgroundColor', this.point.rank_color_code);
    },
    goAuth(){
      this.$router.push({
        name: 'auth-wincal-index',
        params: {pushedWincalLinkButton: true},
      })
    },
    goStayHistory(){
      //loadingを表示
      this.loading = true
      var tonative_req = {
        'destination': this.getDomain() + 'sp/stay-history-external/wincal_stay_history',
        'transition_type': 2,
        'transition_info': 'wincalStayHistory',
        'page_title': "ポイント",
        'feature_id': 'point'
      };
      if (!(this.screenTransition(tonative_req))) {
        this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
      }
      // 処理の最後にローディングを終了させる
      this.loading = false
    },
    async registerNewMember() {
      // 多重処理防止
      if (this.btnDisabledFlg) return;

      try {
        //スピナー表示, ボタンdisabled
        this.loading = true;
        this.btnDisabledFlg = true;

        // ルーティングAPI実行
        await this.routingApi();

        // 画面遷移
        this.transitScreen();
      } catch(e) {
        this.callDialog("通信エラー", "ネットワークの状態が不安定です。再度お試しください", 3);
      } finally {
        // 正常, 異常に関わらず処理完了時はスピナー, ボタンdisabled解除
        this.loading = false
        this.btnDisabledFlg = false
      }
    },
    async routingApi(){
      var routing_req = { params: {
        'sid': this.init.sid,
        'device_uid': this.init.device_uid,
        'key': this.init.key,
        'device_id': this.init.device_id,
        'os': this.init.os,
        'feature_id': 'mypage',
        'service_cd': this.init.service_cd
      }};
      var routing_res = await this.apiCall('/user/routing', routing_req, 'get');
      this.$set(this, 'routingResult', routing_res);
    },
    transitScreen(){
      var tonative_req = {
        'destination': this.routingResult.destination,
        'feature_id': this.routingResult.feature_id,
        'screen_id': this.routingResult.screen_id,
        'transition_type': this.routingResult.transition_type,
        'user_id': this.init.user_id,
        'user_name': this.init.user_name,
        'device_uid': this.init.device_uid,
      };
      if (!(this.screenTransition(tonative_req))) {
        this.callDialog("通信エラー", "ネットワークの状態が不安定です。再度お試しください", 3);
      }
    }
  },
};
</script>

<style scoped>
.header{
  font-weight: bold;
}
.point{
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
  justify-content: center;
}
.big-point {
  font-size: 40px;
  font-weight: bold;
  font-family: "Arial", sans-serif !important;
  color: #333333;
  line-height: 1;
}
.small-bold-text {
  font-size: 20px;
  font-weight: bold;
  font-family: "Oswald", sans-serif !important;
  color: #333333;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  font-weight: bold;
}
.right-align {
  justify-self: end;
}
.left-align {
  justify-self: start;
  text-align: left;
  overflow-wrap: break-word;
}
</style>
<style>
.v-application--wrap {
  min-height: 100vh;
  min-height: -webkit-fill-available;
}
</style>
